import { useState } from "react";

import { searchCustomer } from "src/apis/customerApi";
import { getItemPopupList } from "src/apis/itemApi";
import { SearchCodeModalForm } from "src/components/common/form/search/SearchCodeModalForm";
import { SearchDateRangeForm } from "src/components/common/form/search/SearchDateRangeForm";
import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { SearchSectionDoubleForm } from "src/components/common/form/search/SearchSectionDoubleForm";
import { useInfoFormEvents } from "src/hooks/useInfoFormEvents";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import useUiuxStore from "src/store/useUiuxStore";
import { InfoCodeSearchFieldConfig } from "src/types/info-form";

import {
	defaultKSK1120_R01Filter,
	useKSK1120_R01Store,
} from "./Store_KSK1120_R01";

export const SearchSection_KSK1120_R01 = () => {
	const { KSK1120_R01Filter, setKSK1120_R01Filter } = useKSK1120_R01Store();
	const { setCodeSearchModalProps } = useUiuxStore();
	const { compCdList } = useCommonCodeStore();
	const [pickerVisible, setPickerVisible] = useState(false);
	const [pickerPosition, setPickerPosition] = useState({ top: 0, left: 0 });
	const customerFocusId = "KSK1120_R01-customCd-search";
	const itemFocusId = "KSK1120_R01-itemCd-search";
	const codeModalWrapperOption = {
		wrapperStyle: "w-[600px] min-w-[600px] mr-[10px]",
		titleStyle: "w-[80px] min-w-[80px] text-left",
		codeInputStyle: "w-[190px] min-w-[190px]",
		nameTagStyle: "w-[300px] min-w-[300px] text-left",
	};

	const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
		{
			fieldName: "customCd",
			category: "거래처",
			focusId: customerFocusId,
			responseMapping: { customCd: "customCd", customNm: "customNm" },
			searchFunction: async (searchText: string) => {
				const response = await searchCustomer(searchText);
				return response.data.data.find((value) => value.customCd === searchText);
			},
			extraFilter: () => ({
				customCd: KSK1120_R01Filter.customCd,
				customNm: KSK1120_R01Filter.customNm,
			}),
		},
		{
			fieldName: "itemCd",
			category: "품목",
			focusId: itemFocusId,
			responseMapping: { itemCd: "itemCd", itemNm: "itemNm" },
			searchFunction: async (searchText: string) => {
				const response = await getItemPopupList(searchText, "", "", "");
				return response.data.data.find((value) => value.itemCd === searchText);
			},
			extraFilter: () => ({
				itemCd: KSK1120_R01Filter.itemCd,
				itemNm: KSK1120_R01Filter.itemNm,
			}),
		},
	];

	const { getFieldHandlers } = useInfoFormEvents({
		editData: KSK1120_R01Filter,
		setEditData: setKSK1120_R01Filter,
		defaultData: defaultKSK1120_R01Filter,
		infoFieldConfigs,
		setCodeSearchModalProps,
		formName: "KSK1120_R01-search",
	});

	return (
		<SearchSectionDoubleForm>
			<SearchDropDownForm
				label="사업장"
				value={KSK1120_R01Filter.compCd}
				optionList={compCdList}
				onChangeValue={(compCd) => setKSK1120_R01Filter({ compCd })}
			/>
			<SearchDateRangeForm
				label="출고기간"
				visible={pickerVisible}
				setVisible={setPickerVisible}
				dateRange={KSK1120_R01Filter.dateRange}
				setDateRange={(dateRange) => setKSK1120_R01Filter({ dateRange })}
				pickerPosition={pickerPosition}
				setPickerPosition={setPickerPosition}
			/>
			<SearchCodeModalForm
				label="거래처"
				value={KSK1120_R01Filter.customCd}
				valueLabel={KSK1120_R01Filter.customNm}
				handleFoucsId={customerFocusId}
				onChange={getFieldHandlers("customCd").onChange}
				onDoubleClick={getFieldHandlers("customCd").onDoubleClick}
				onKeyDown={getFieldHandlers("customCd").onEnterKeyDown}
				wrapperOption={codeModalWrapperOption}
			/>
			<SearchCodeModalForm
				label="품목코드"
				value={KSK1120_R01Filter.itemCd}
				valueLabel={KSK1120_R01Filter.itemNm}
				handleFoucsId={itemFocusId}
				onChange={getFieldHandlers("itemCd").onChange}
				onDoubleClick={getFieldHandlers("itemCd").onDoubleClick}
				onKeyDown={getFieldHandlers("itemCd").onEnterKeyDown}
				wrapperOption={codeModalWrapperOption}
			/>
		</SearchSectionDoubleForm>
	);
};
